import config from './env-config.json';

interface IAuthConfig {
  clientId: string;
  domain: string;
  idpName: string;
  logoutUri: string;
  redirectUri: string;
  responseType: string;
  scope: string;
}

interface IEnvConfig {
  auth: IAuthConfig;
  ccpUrl: string;
  azureTenant: string;
  upEnvironment: string;
  apiBaseUrl: string;
  isProd?: boolean;
}

interface IEnvsConfig {
  [host: string]: IEnvConfig;
}

/*******************************************************************************
 * env-config.js includes environment configuration for the app
 ******************************************************************************/

/**
 * @type {EnvironmentConfig}
 */
console.log(window.location.hostname);
const envConfig = (config as IEnvsConfig)[window.location.hostname];
envConfig.isProd = envConfig.upEnvironment === 'PRODUCTION';

/*******************************************************************************
 * exported api definition
 ******************************************************************************/
export default envConfig;
